var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31245 25.7287C7.94125 26.0592 7.90831 26.6281 8.23888 26.9993C8.56944 27.3705 9.13834 27.4035 9.50954 27.0729L21.5985 15.7138C21.9837 15.3707 22.0024 14.7747 21.6394 14.4083L9.55038 2.96738C9.20057 2.61426 8.63073 2.61157 8.2776 2.96139C7.92448 3.3112 7.9218 3.88104 8.27161 4.23417L19.6926 15.0008L8.31245 25.7287Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.738b6d92733b164196ca73f147d614f8.svg";
export { ForwardRef as ReactComponent };